(function(){
    const ignorePersonUrl = `/service/home/pie/users/${FS.User.getEffectiveId()}/ignored/persons/`
    const Action = {
        hide: 'HIDE',
        unHide: 'UN-HIDE',
        ignore: 'IGNORE',
        unIgnore: 'UN-IGNORE',
        report: 'REPORT',
        event: 'home-feed-action',
        reportEvent: 'start-abuse-report',
        removePersonEvent: 'open-remove-person-dialog'
    }

    /**
     *  Hide activity from home feed.
     *
     * @param {object} activity activity object form home feed
     * @returns {promise} promise that returns nothing
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function hideActivity(activity) {
        return _handlePromise(Home.Taz.dismissActivity(activity.id), Action.hide, activity)
    }

    /**
     * Un-hide activity in home feed.
     *
     * @param {object} activity activity object form home feed
     * @returns {promise} promise that returns nothing
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function undoHideActivity(activity) {
        return _handlePromise(Home.Taz.restoreActivity(activity.id), Action.unHide, activity)
    }

    /**
     * Hide person from home page.
     *
     * @param {object} activity activity object form home feed
     * @returns {promise} promise that returns nothing
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function hidePerson(activity) {
        return _handlePromise(FS.fetch(`${ignorePersonUrl}${activity.personId}`, {method: 'POST'}), Action.ignore, activity)
    }

    /**
     * Un-hide person from home page.
     *
     * @param {object} activity activity object form home feed
     * @returns {promise} promise that returns nothing
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function undoHidePerson(activity) {
        return _handlePromise(FS.fetch(`${ignorePersonUrl}${activity.personId}`, {method: 'DELETE'}), Action.unIgnore, activity)
    }

    /**
     * Fires event to open the report dialog.
     * @param {object} activity activity object form home feed
     *
     * @fires Home.Feed.Action.reportEvent:start-abuse-report
     *
     * @returns {undefined} returns nothing
     */
    function showReportActivity(activity) {
        const detail = {activity}
        /**
         * @event Home.Feed.Action.reportEvent:start-abuse-report
         * @type {object}
         * @property {object} activity memory or source
         */
        const event = new CustomEvent(Action.reportEvent, {detail})
        document.dispatchEvent(event)
    }

    /**
     * Emit event on success of the report dialog
     *
     * @param {object} activity activity object form home feed
     * @param {boolean} success indication if report was successfully sent
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function reportActivity(activity, success) {
        let promise = new Promise((resolve, reject) => {
            if (success) {
                hideActivity(activity)
                resolve()
            } else {
                const error = new Error('Home feed activity report failed')
                reject(error)
            }
        })
        return _handlePromise(promise, Action.report, activity)
    }

    /**
     * Handle then and catch of promise for home feed actions.
     *
     * @param {promise} promise promise to be handled
     * @param {String} type type of action taken
     * @param {object} activity activity object to be passed on in event
     *
     * @fires Home.Feed.Action.event:home-feed-action
     *
     * @returns {promise} promise resolves null, emits an event
     */
    function _handlePromise(promise, type = '', activity = {}) {
        const detail = {activity, type, finished: false, error: null}
        /**
         * Home feed action event fires when an action that can change the home feed starts or is finished.
         *
         * @event Home.Feed.Action.event:home-feed-action
         * @type {object}
         * @property {object} activity memory or source
         * @property {string} type type of action take
         * @property {boolean} finished if the promise is finished or not
         * @property {object} error Error is set, null otherwise
         */
        const eventStart = new CustomEvent(Action.event, {detail})
        document.dispatchEvent(eventStart)
        return promise
        .then(() => {
            // used to prevent cached results when a person or activity is removed
            sessionStorage.setItem('Home.Feed.Change', Math.random())
            detail.finished = true
            const eventFinished = new CustomEvent(Action.event, {detail})
            document.dispatchEvent(eventFinished)
        })
        .catch(e => {
            // logging out error for sentry to catch
            console.error(e)
            detail.error = e
            detail.finished = true
            const eventFinished = new CustomEvent(Action.event, {detail})
            document.dispatchEvent(eventFinished)
        })
    }

    /**
     * show remove person from feed dialog
     *
     * @param {object} activity activity object form home feed
     *
     * @event Home.Feed.Action.removePersonEvent:open-remove-person-dialog
     * @type {object}
     * @property {object} activity activity object form home feed'
     *
     * @returns {undefined}
     */
    function showHidePersonDialog(activity) {
        const detail = {activity}
        const event = new CustomEvent('open-remove-person-dialog', {detail})
        document.dispatchEvent(event)
    }

    window.Home = window.Home || {}
    Home.Feed = {
        hideActivity,
        undoHideActivity,
        showHidePersonDialog,
        hidePerson,
        undoHidePerson,
        showReportActivity,
        reportActivity,
        Action
    }
}())